import { useQuery } from "@tanstack/react-query";
import fetchWrapper from "../../api/fetchWrapper";
import { ENDPOINT } from "../../api/endpoint";
import { DashboardFilterType } from "../../interface";
import { useEffect, useState } from "react";
import { formatDashboardData } from "../../utils/helper";

const useGetDashboardData = (filters: DashboardFilterType) => {
  const [data, setData] = useState<any>({});
  const {
    data: dataFromAPI,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["dashboardData", filters],
    queryFn: () =>
      fetchWrapper(ENDPOINT.GET_DASHBOARD_DATA, {
        method: "POST",
        body: filters,
      }),
    retry: false,
  });

  useEffect(() => {
    if (dataFromAPI && !isLoading) {
      setData(formatDashboardData(dataFromAPI));
    }
  }, [dataFromAPI, isLoading]);

  return { data, isLoading, isError, error };
};

export default useGetDashboardData;
